import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { Message } from 'element-ui'
import { $t } from '@/i18n'
import { buildUriForCall } from '@/helpers/functions/buildUri'

// Ignore les réponses obsolètes si l'utilisateur change vite de page / filtre
let loadReportRequestId = 0

export default {
  namespaced: true,
  state: {
    loadingReportByPortal: false,
    filters: {
      search: '',
      page: 1,
      perPage: 10
    },
    total: 0,
    diffuseur: {
      diffuseurNomDeCode: '',
      nbAnnoncesMax: 0,
      nbAnnoncesQuota: 0,
      modeSelectionAutomatique: '',
      nbAnnoncesSelectionnees: 0,
      id: 0,
      nom: '',
      logo: null
    },
    annonces: [],
    statistiques: {
      idUniq: '',
      idFlux: null,
      annonceur: 0,
      bilanAnnonces: {
        modifies: 0,
        traites: 0,
        identiques: 0,
        ajoutes: 0,
        non_valides: 0,
        diffusees: 0,
        supprimes: 0
      },
      bilanPhotos: [],
      type: '',
      startDate: null,
      endDate: null,
      serveur: '',
      idTraitement: 0,
      idFluxPartenaire: 0,
      codeFluxPartenaire: '',
      nomFluxPartenaire: ''
    },
    messagesExports: []
  },
  getters: {
    getLoadingReportByPortal: (state) => state.loadingReportByPortal,
    getNbAnnoncesMax: (state) => state.diffuseur.nbAnnoncesMax,
    getNbAnnoncesQuota: (state) => state.diffuseur.nbAnnoncesQuota,
    getModeSelectionAutomatique: (state) => state.diffuseur.modeSelectionAutomatique,
    getNbAnnoncesSelectionnees: (state) => state.diffuseur.nbAnnoncesSelectionnees,
    getNomDiffuseur: (state) => state.diffuseur.nom,
    getLogoDiffuseur: (state) => state.diffuseur.logo,
    getStatistics: (state) => state.statistiques,
    getDateEnd: (state) => state.statistiques.endDate,
    getNbAnnoncesTraitees: (state) => state.statistiques.bilanAnnonces.traites,
    getNbAnnoncesDiffusees: (state) => state.statistiques.bilanAnnonces.diffusees,
    getAnnoncesReportByPortal: (state) => state.annonces,
    getFilters: (state) => state.filters,
    getTotalReportPortal: (state) => state.total,
    getMessagesExportDiffusionByPortal: (state) => state.messagesExports
  },
  mutations: {
    setLoadingReportByPortal (state, bool) {
      state.loadingReportByPortal = bool
    },
    setResults (state, data) {
      state.diffuseur = data.diffuseur
      state.statistiques = data.statistiques
      state.annonces = data.annonces
    },
    setTotal (state, total) {
      state.total = total
    },
    setFilters (state, { key, value }) {
      state.filters[key] = value
    },
    setMessagesExport (state, data) {
      state.messagesExports = data
    },
    resetFilter (state) {
      state.filters.search = ''
      state.filters.page = 1
    }
  },
  actions: {
    loadReportByPortal ({ state, commit, rootState }, { diffuseur }) {
      const language = rootState.app.sitimmoUser.language
      const requestId = ++loadReportRequestId
      commit('setLoadingReportByPortal', true)
      const path = `/portals/report/${diffuseur}/${language}`
      const url = buildUriForCall(path, {
        page: state.filters.page,
        perPage: state.filters.perPage,
        search: state.filters.search
      })
      return HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
          if (requestId !== loadReportRequestId) {
            return
          }
          commit('setTotal', response.data.total)
          commit('setResults', response.data)
        })
        .catch((error) => {
          if (requestId !== loadReportRequestId) {
            return
          }
          Message.error($t('serverError500'))
          throw error
        }).finally(() => {
          if (requestId === loadReportRequestId) {
            commit('setLoadingReportByPortal', false)
          }
        })
    },
    async exporterDiffusionByPortal ({ state, rootState }, { diffuseur } = {}) {
      const language = rootState.app.sitimmoUser.language
      const code = diffuseur
      if (!code) {
        return []
      }
      const path = `/portals/report/${code}/${language}`
      const url = buildUriForCall(path, {
        export: 'messages',
        search: state.filters.search
      })
      try {
        const response = await HTTP_HYPER_ESPACE_BACKEND.get(url)
        return Array.isArray(response.data) ? response.data : []
      } catch (error) {
        Message.error($t('serverError500'))
        return []
      }
    }
  }
}
